import * as React from "react";

import { cellErrors } from "@/react/components/table/useTableMutations";
import { CopyButton } from "@/react/components/CopyButton";
import parseValue from "@/react/validation/parseValue";
import formatDuration from "@/react/datetime/formatDuration";

import HasErrorSpan from "../HasErrorSpan";
import StyledValidationWrapper from "../StyledValidationWrapper";

const Cell = React.memo((cell) => {
  const rawValue = cell?.getValue() ?? 0;
  const parsedValue = parseValue(rawValue);
  const duration = formatDuration(parsedValue);

  const errors = cellErrors(cell);
  const customFormatCell = cell?.column.columnDef.customCell;
  const disableCopy = cell?.column.columnDef.disableCopy === true;

  return (
    <>
      <StyledValidationWrapper errors={errors}>
        <HasErrorSpan hasError={errors?.length > 0} title={duration}>
          {customFormatCell ? customFormatCell(parsedValue) : duration}
        </HasErrorSpan>
      </StyledValidationWrapper>
      {duration && !disableCopy && <CopyButton value={duration} />}
    </>
  );
});

export default Cell;
